import React from 'react';
import type { TestimonialComponent } from '../../../types/builder';
import { Star } from 'lucide-react';

interface TestimonialRendererProps {
  component: TestimonialComponent;
}

export const TestimonialRenderer: React.FC<TestimonialRendererProps> = ({ component }) => {
  const { avatarUrl, name, role, rating, review, backgroundColor, textColor, starColor, avatarSize, padding } = component.settings;

  return (
    <div
      style={{
        padding: `${padding}px`,
        backgroundColor,
        borderRadius: '16px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        maxWidth: '600px',
        margin: '0 auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '16px',
        }}
      >
        {/* Avatar */}
        <div
          style={{
            width: `${avatarSize}px`,
            height: `${avatarSize}px`,
            borderRadius: '50%',
            overflow: 'hidden',
            flexShrink: 0,
            border: '3px solid rgba(255, 255, 255, 0.5)',
          }}
        >
          <img
            src={avatarUrl}
            alt={name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).src = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(name) + '&size=200&background=667eea&color=fff';
            }}
          />
        </div>

        {/* Name and Role */}
        <div style={{ flex: 1 }}>
          <h3
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: textColor,
              margin: '0 0 4px 0',
            }}
          >
            {name}
          </h3>
          <p
            style={{
              fontSize: '14px',
              color: textColor,
              opacity: 0.7,
              margin: '0',
            }}
          >
            {role}
          </p>
        </div>
      </div>

      {/* Rating */}
      <div
        style={{
          display: 'flex',
          gap: '4px',
          marginBottom: '12px',
        }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <Star
            key={index}
            size={20}
            fill={index < rating ? starColor : 'transparent'}
            color={index < rating ? starColor : '#d1d5db'}
          />
        ))}
      </div>

      {/* Review */}
      <p
        style={{
          fontSize: '16px',
          color: textColor,
          lineHeight: '1.6',
          margin: '0',
          fontStyle: 'italic',
        }}
      >
        "{review}"
      </p>
    </div>
  );
};

